import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback } from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import withCurrentGallectionSubfolders from '../../_hocs/withCurrentGallectionSubfolders';
import { moveGallectionToPosition as moveGallectionToPositionAction } from '../../actions';
import { DndSortable, DndSortableElement } from '../../../Dnd/DndSortable';
import { DraggableType } from '../../../types/dnd';
import SubfolderSlider from '../SubfolderSlider';
import ManageableSubfolder from './ManageableSubfolder';
import manageableSubfolderSliderStyles from './ManageableSubfolderSlider.scss';
const enhance = compose(withCurrentGallectionSubfolders, connectMediaStore(null, {
    moveGallectionToPosition: moveGallectionToPositionAction
}));
export const ManageableSubfolderSlider = ({ subfolders, moveGallectionToPosition })=>{
    const onDrop = useCallback((folderId, position)=>moveGallectionToPosition({
            folderId,
            position,
            moveType: 'papiOnly'
        }), [
        moveGallectionToPosition
    ]);
    const onDragOver = useCallback((folderId, position)=>moveGallectionToPosition({
            folderId,
            position,
            moveType: 'streamOnly'
        }), [
        moveGallectionToPosition
    ]);
    if (!subfolders.length) {
        return null;
    }
    const existingGallectionNames = subfolders.map((gallection)=>gallection.name);
    return /*#__PURE__*/ React.createElement(DndSortable, {
        onDrop: onDrop,
        onDragOver: onDragOver
    }, (_param)=>{
        var { draggedElementId } = _param, dndProps = _object_without_properties(_param, [
            "draggedElementId"
        ]);
        return /*#__PURE__*/ React.createElement(SubfolderSlider, {
            disableArrows: !!draggedElementId
        }, subfolders.map((subfolder, index)=>/*#__PURE__*/ React.createElement(DndSortableElement, _object_spread({
                dndType: DraggableType.MEDIA_MANAGER_SLIDER_GALLECTION,
                id: subfolder.folderId,
                key: subfolder.folderId,
                position: index
            }, dndProps), (sortableOptions)=>/*#__PURE__*/ React.createElement("div", {
                    ref: sortableOptions.ref,
                    className: classnames(draggedElementId === subfolder.folderId && manageableSubfolderSliderStyles['dragging'])
                }, /*#__PURE__*/ React.createElement(ManageableSubfolder, {
                    key: index,
                    subfolder: subfolder,
                    existingGallectionNames: existingGallectionNames
                })))));
    });
};
ManageableSubfolderSlider.displayName = 'SubfolderSliderSelector';
export default enhance(ManageableSubfolderSlider);

//# sourceMappingURL=ManageableSubfolderSlider.js.map